// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"eb09f77aae333d9ea6de","655":"480c440e7e54340b7e39"}[chunkId] + ".js";
};